export default "__VITE_ASSET__$zYEjC$A__"